var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner app-main-page push-config" },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  "label-width": "100px",
                  "label-position": "right"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "50px",
                          label: _vm.$t("SystemMaintenance.Branch")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function($event) {
                                _vm.getPushConfig(_vm.branchId),
                                  _vm.getPersonalEmail(_vm.branchId)
                              }
                            },
                            model: {
                              value: _vm.branchId,
                              callback: function($$v) {
                                _vm.branchId = $$v
                              },
                              expression: "branchId"
                            }
                          },
                          _vm._l(_vm.currentOfficeList, function(office) {
                            return _c("el-option", {
                              key: office.uuid,
                              attrs: {
                                value: office.officeId,
                                label: office.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.branchId !== 1,
                            expression: "branchId!==1"
                          }
                        ],
                        attrs: {
                          label: _vm.$t(
                            "SystemMaintenance.ApplyTheHeadOfficesSettings"
                          )
                        }
                      },
                      [
                        _c("el-checkbox", {
                          on: { change: _vm.applyHeadOfficeConfig },
                          model: {
                            value: _vm.pushConfigForm.ifApplied,
                            callback: function($$v) {
                              _vm.$set(_vm.pushConfigForm, "ifApplied", $$v)
                            },
                            expression: "pushConfigForm.ifApplied"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c("br"),
            _vm.$checkPermission(["role_pushConfig_saveButton"])
              ? _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.saveConfig()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.save")) + " ")]
                )
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "triggers" })
      ]),
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.pushConfigForm.ifApplied,
                "label-width": "120px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "5px" } },
                    [
                      _c("el-checkbox", {
                        attrs: {
                          label: _vm.$t("SystemMaintenance.EnableAutomaticPush")
                        },
                        model: {
                          value: _vm.pushConfigForm.ifAuto,
                          callback: function($$v) {
                            _vm.$set(_vm.pushConfigForm, "ifAuto", $$v)
                          },
                          expression: "pushConfigForm.ifAuto"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "el-form-item-wrapper" }, [
                _c(
                  "fieldset",
                  [
                    _c("legend", [
                      _vm._v(
                        _vm._s(_vm.$t("SystemMaintenance.BasicConfiguration"))
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "200px",
                          label: _vm.$t("SystemMaintenance.SOPPushChannel")
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.pushConfigForm.ifEmail,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "ifEmail", $$v)
                              },
                              expression: "pushConfigForm.ifEmail"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Email")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.pushConfigForm.ifNote,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "ifNote", $$v)
                              },
                              expression: "pushConfigForm.ifNote"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.SMS")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.pushConfigForm.ifEnterpriseWechat,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pushConfigForm,
                                  "ifEnterpriseWechat",
                                  $$v
                                )
                              },
                              expression: "pushConfigForm.ifEnterpriseWechat"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_EnterpriseWechat"))
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "200px",
                          label: _vm.$t(
                            "SystemMaintenance.PushOnlyAfterConfirmingRecipient"
                          )
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.pushConfigForm.ifSop,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "ifSop", $$v)
                              },
                              expression: "pushConfigForm.ifSop"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.Open")))
                            ]),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v(_vm._s(_vm.$t("SystemMaintenance.Close")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "200px",
                          label:
                            _vm.$t(
                              "queryJob.MatchingConditionsForPushSOPReceiver"
                            ) + ":"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.pushConfigForm.ifAirline,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "ifAirline", $$v)
                              },
                              expression: "pushConfigForm.ifAirline"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("queryJob.route")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pushConfigForm.ifEmail,
                      expression: "pushConfigForm.ifEmail"
                    }
                  ],
                  staticClass: "el-form-item-wrapper"
                },
                [
                  _c(
                    "fieldset",
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content: _vm.$t(
                              "SystemMaintenance.PleaseSendersEmailWhichEmails"
                            ),
                            placement: "top-end"
                          }
                        },
                        [
                          _c("legend", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SystemMaintenance.EmailConfiguration")
                              )
                            ),
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                cursor: "pointer",
                                "margin-left": "4px"
                              }
                            })
                          ])
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        { attrs: { checked: "", disabled: "" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.SystemEmail"))
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.Username2")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.systemEmail,
                              callback: function($$v) {
                                _vm.systemEmail = $$v
                              },
                              expression: "systemEmail"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.mailServerForm.enable,
                            callback: function($$v) {
                              _vm.$set(_vm.mailServerForm, "enable", $$v)
                            },
                            expression: "mailServerForm.enable"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.CompanyEmail"))
                          )
                        ]
                      ),
                      _c("div", { staticStyle: { display: "flex" } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemMaintenance.Username2")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.mailServerForm.enable
                                  },
                                  model: {
                                    value: _vm.mailServerForm.authSender,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "authSender",
                                        $$v
                                      )
                                    },
                                    expression: "mailServerForm.authSender"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.EmailPasswordauthorizationCode"
                                  )
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mailServerForm.authSenderPwd,
                                      expression: "mailServerForm.authSenderPwd"
                                    }
                                  ],
                                  staticClass: "password",
                                  attrs: {
                                    type: "password",
                                    disabled: !_vm.mailServerForm.enable
                                  },
                                  domProps: {
                                    value: _vm.mailServerForm.authSenderPwd
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "authSenderPwd",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.EmailDisplayName"
                                  )
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.mailServerForm.enable
                                  },
                                  model: {
                                    value: _vm.mailServerForm.senderMail,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "senderMail",
                                        $$v
                                      )
                                    },
                                    expression: "mailServerForm.senderMail"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SystemMaintenance.SenderServer"
                                  )
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.mailServerForm.enable
                                  },
                                  model: {
                                    value: _vm.mailServerForm.smtpHost,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "smtpHost",
                                        $$v
                                      )
                                    },
                                    expression: "mailServerForm.smtpHost"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SystemMaintenance.Port")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: !_vm.mailServerForm.enable
                                  },
                                  model: {
                                    value: _vm.mailServerForm.smtpPort,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "smtpPort",
                                        $$v
                                      )
                                    },
                                    expression: "mailServerForm.smtpPort"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("Tool.UseSsl") } },
                              [
                                _c("el-checkbox", {
                                  attrs: { "true-label": 1, "false-label": 0 },
                                  model: {
                                    value: _vm.mailServerForm.smtpSsl,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mailServerForm,
                                        "smtpSsl",
                                        $$v
                                      )
                                    },
                                    expression: "mailServerForm.smtpSsl"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", height: "220px" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "30px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SystemMaintenance.Signature"))
                                )
                              ]
                            ),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "400px",
                                    position: "relative",
                                    height: "200px"
                                  }
                                },
                                [
                                  _c("div", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.mailServerForm.enable ||
                                          _vm.pushConfigForm.ifApplied,
                                        expression:
                                          "!mailServerForm.enable || pushConfigForm.ifApplied"
                                      }
                                    ],
                                    staticClass: "mask"
                                  }),
                                  _c("quill-editor", {
                                    ref: "myQuillEditor",
                                    staticStyle: { height: "150px" },
                                    attrs: { options: _vm.editorOption },
                                    on: {
                                      change: function($event) {
                                        return _vm.onEditorChange($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.mailServerForm.sign,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.mailServerForm,
                                          "sign",
                                          $$v
                                        )
                                      },
                                      expression: "mailServerForm.sign"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        "true-label": 1,
                                        "false-label": 0
                                      },
                                      model: {
                                        value: _vm.mailServerForm.enableSign,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mailServerForm,
                                            "enableSign",
                                            $$v
                                          )
                                        },
                                        expression: "mailServerForm.enableSign"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SystemMaintenance.EnableSignature"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ]),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          on: { change: _vm.onPersonalEmailEnableChange },
                          model: {
                            value: _vm.emailConfiguration.enable,
                            callback: function($$v) {
                              _vm.$set(_vm.emailConfiguration, "enable", $$v)
                            },
                            expression: "emailConfiguration.enable"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.PersonalEmail"))
                          )
                        ]
                      ),
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: {
                          cursor: "pointer",
                          "margin-left": "4px"
                        },
                        on: { click: _vm.showPersonalEmailTip }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pushConfigForm.ifNote,
                      expression: "pushConfigForm.ifNote"
                    }
                  ],
                  staticClass: "el-form-item-wrapper"
                },
                [
                  _c(
                    "fieldset",
                    [
                      _c("legend", [
                        _vm._v(
                          _vm._s(_vm.$t("SystemMaintenance.SMSConfiguration"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "Message.ChineseAbbreviationOfTheCompany"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.pushConfigForm.noteChinese,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "noteChinese", $$v)
                              },
                              expression: "pushConfigForm.noteChinese"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SystemMaintenance.CompanyEnglishAbbreviation"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.pushConfigForm.noteEnglish,
                              callback: function($$v) {
                                _vm.$set(_vm.pushConfigForm, "noteEnglish", $$v)
                              },
                              expression: "pushConfigForm.noteEnglish"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.personalEmailTipVisible,
            title: _vm.$t("SystemMaintenance.SetPersonalEmail"),
            width: "600px",
            "close-on-click-modal": false,
            "custom-class": "personal-email-tip"
          },
          on: {
            "update:visible": function($event) {
              _vm.personalEmailTipVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.$t("SystemMaintenance.Note")) + ":")
              ]),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.SetPersonalEmailNote1"))
                )
              ]),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.SetPersonalEmailNote2"))
                )
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.SetPersonalEmailStep1"))
                )
              ]),
              _c("img", {
                staticStyle: { width: "250px" },
                attrs: { src: require("@/assets/personalMailTip1.png") }
              }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.SetPersonalEmailStep2"))
                )
              ]),
              _c("img", {
                staticStyle: { width: "400px" },
                attrs: { src: require("@/assets/personalMailTip2.png") }
              }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.SetPersonalEmailStep3"))
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    "padding-left": "40px",
                    "padding-right": "40px"
                  },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.personalEmailTipVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }